(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[53628],{

/***/ 38340:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules",
      function () {
        return __webpack_require__(31761);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_rules; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
;// CONCATENATED MODULE: ./src/constants/contents/rules.tsx


var Rules = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        as: "span",
                        children: "Stockbit"
                    }),
                    " ",
                    "memiliki beberapa panduan yang diharapkan untuk diikuti mayoritas untuk menjaga integritas dan manfaat platform Stockbit."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Pelanggaran atas aturan ini akan ditindaklanjuti tanpa peringatan."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "do-s",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Do's"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Be Nice. Be Respectful"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Jadikan stockbit sebagai platform untuk belajar, baik saham, maupun kepenulisan."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Menghargai pendapat orang lain"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Saring sebelum Sharing"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Memberi masukan atau kritik yang konstruktif"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Memperhatikan sopan santun dan etika dalam berinteraksi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Membagikan ide brilian mu kepada user lain agar saling belajar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "don-t",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Don'ts"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Memposting hal yang serupa dalam waktu yang bersamaan (Spam, advertising)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Provokasi kepada hal yang tidak baik"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "Mengumbar kebencian (termasuk ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "bullying"
                            }),
                            " dan menghasut)"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Menghina orang lain dalam bentuk publik maupun privat"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Menghina SARA"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Mendorong konten pornografi dan sejenisnya"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Menjadikan stockbit sebagai lapak jualan pribadi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "Menyebarkan gambar ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "explicit"
                            }),
                            " (",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "nudity"
                            }),
                            ",",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "abusive behavior"
                            }),
                            ", dsb)"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "Meminta password dan PIN ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "trading"
                            }),
                            " kepada orang lain."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "Memberikan data pribadi berikut dengan password dan PIN ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "trading"
                            }),
                            " ",
                            "kepada orang lain."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "peringatan",
                style: {
                    marginBottom: "0.8em"
                },
                children: "PERINGATAN!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                    children: "Stockbit tidak pernah meminta pengguna untuk memberikan password, PIN trading, atau OTP (One-Time Password) untuk kebutuhan apapun."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "privasi",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Privasi"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Stockbit berkomitmen untuk selalu menjaga data pribadi. Dihimbau untuk",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "TIDAK"
                    }),
                    " memposting dan memberikan segala sesuatu yang memuat data pribadi (seperti KTP, nomor telepon, dan segala jenis identitas lainnya dalam segala bentuk) atau privasi data yang menyangkut dengan institusi yang bersifat rahasia."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Jika ada aktivitas atau pihak mencurigakan yang memberikan kontak seakan-akan milik Stockbit, segera lapor dan verifikasi ke Customer Support Stockbit melalui WhatsApp +622150864219 atau email support@stockbit.com."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Stockbit tidak bertanggung jawab atas kerugian materil dan immaterial yang disebabkan penyebaran data pribadi oleh pengguna."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "ide-berkualitas",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Ide Berkualitas"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Untuk membangun suatu komunitas saham yang berkualitas, kami berharap semua ide yang di share di Stockbit dapat disertai alasan yang menarik dengan landasan yang kuat untuk dijadikan tempat pembelajaran."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    as: "span",
                    children: "Hal yang perlu kamu hindari:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Menyebarkan rumor palsu tentang saham tertentu."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Posting message yang sangat mirip beberapa kali dengan tujuan menggiring perhatian publik terhadap suatu saham."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Memberi $ tag untuk suatu post yang tidak berkualitas. Hal-hal yang tidak penting sebaiknya tidak perlu di tag."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Menulis hal yang bersifat tidak relevan untuk dibagikan di forum saham."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "Repost"
                            }),
                            " konten secara berkala dengan tujuan pom-pom atau promosi."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Membagikan password, PIN trading dan data lainnya yang bersifat pribadi kepada orang lain."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Kami berharap tujuan semua untuk sharing ide di Stockbit adalah untuk saling belajar dari sesama."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "dilarang-iklan",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Dilarang Iklan"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Kami berharap anggota Stockbit tidak mempromosikan produk dan jasa kepada anggota lain. Berikut adalah kegiatan yang tidak diizinkan:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Pesan yang berisi promosi dagang atau jasa, termasuk grup saham gratis maupun berbayar."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Pesan yang berisi promosi tentang aplikasi investasi selain milik grup Stockbit."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Mengirim reply, mention atau private message untuk mempromosikan layanan atau produk berbayar."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Membuka lapak jualan di stockbit"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "tip-jar",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Tip Jar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Tip Jar hanya dapat digunakan untuk memberikan apresiasi kepada para penulis pada Stockbit Stream berbentuk uang dengan nominal tertentu. Berikut hal yang tidak bisa dilakukan dengan fitur Tip Jar:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Dilarang berjualan grup berbayar atau premium dengan transaksi melalui Tip Jar."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "Dilarang memberikan Tip Jar dengan motif untuk mendapatkan rekomendasi berbentuk ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "stockpick"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Dilarang memanfaatkan Tip Jar sebagai alat transaksi ilegal."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Harap memanfaatkan fitur Tip Jar dengan baik dan benar. Segala bentuk penyalahgunaan fitur Tip Jar akan kami tindak tegas sesuai prosedur yang berlaku."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "etika",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Etika"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Kami berharap Stockbitor bisa menjaga etika yang baik supaya komunitas kita bisa berfungsi dengan harmonis. Berikut bisa dipakai sebagai panduan:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Jujur jika membuat kesalahan. Semua orang bisa salah termasuk analis yang paling handal pun. Yang penting adalah cara kita mengatasi kesalahan kita."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Selalu rendah hati dan menghargai orang lain, sekalipun kamu mampu melakukan analisa yang baik."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Ide di Stockbit sebaiknya diperlakukan sebagai dorongan untuk berpikir dan membuat analisa kita sendiri."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Jangan mengikuti rekomendasi orang tanpa mempertimbangkan resikonya terlebih dahulu. Resiko selalu kita tanggung masing-masing."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "perlakuan-kasar",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Perlakuan Kasar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Kami melarang keras adanya serangan pribadi kepada user lain maupun anggota kami di Stockbit. Perilaku berikut tidak diizinkan:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Mengirim pesan yang bersifat menghina atau melecehkan orang lain di Stockbit."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Mengirim pesan yang mengancam orang lain di Stockbit."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Mengirim pesan yang menghina atau bersifat rasis terhadap anggota kami di Stockbit."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Menggunakan bahasa vulgar dan/atau tidak berkenan di Stockbit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Posting yang berbau SARA (Suku, Agama, Ras, Antar golongan), pornografi dan segala sesuatu yang tidak sesuai untuk ditampikan secara publik. Hal Ini termasuk pemilihan username dan foto profil yang tidak sesuai dengan standar dan peraturan stockbit"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Perlakuan kasar dapat dianggap sebagai tindakan pidana. Stockbit tidak bertanggung jawab atas tindakan pengguna kami dan akan bekerja sama sepenuhnya dengan pihak berwenang jika tindakan tersebut dibawa ke ranah hukum."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "disclaimer-always-on",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Disclaimer Always On"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Semua postingan dari pengguna Stockbit bukan rekomendasi untuk membeli atau menjual, melainkan hanya sesuatu ide untuk dipertimbangkan. Maka dari itu, kamu sendiri yang bertanggung jawab untuk menentukan apakah investasi, strategi berikut sesuai untuk kamu. Setiap post mempunyai disclaimer. Silahkan baca ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/terms",
                        children: "Terms of Service"
                    }),
                    " kami."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Aturan-aturan ini dibuat untuk kepentingan bersama. Pelanggaran akan ditindaklanjuti",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        as: "span",
                        children: "tanpa peringatan"
                    }),
                    ". Keputusan admin merupakan final atas aksi individu tanpa melihat konteks sebelumnya dan tanpa arbitrase berkelanjutan. Kami mohon untuk kebijakan semua anggota dalam menulis di Stockbit."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    as: "span",
                    children: "***"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h3",
                id: "faq",
                style: {
                    marginBottom: "0.8em"
                },
                children: "FAQ"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h4",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Apa itu House Rules?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "House Rules adalah peraturan yang dibuat oleh Superadmin dengan tujuan untuk menjaga percakapan dalam diskusi di Stockbit Stream tetap nyaman dan kondusif."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Pelanggaran House Rules dapat dikenakan sanksi mulai dari teguran, penangguhan hingga penghapusan akun."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h4",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Bagaimana Jika Saya Melanggar House Rules?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Jika kamu melanggar, moderator kami memiliki hak untuk melakukan penindakan, mulai dari penindakan",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "mute"
                        })
                    }),
                    ", menghapus, hingga menangguhkan akunmu."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Moderator juga berhak untuk menghapus segala postingan bernada provokasi dan berpotensi menimbulkan kegaduhan."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Jika kamu menemukan postingan dengan ciri-ciri yang melanggar",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "House Rules"
                    }),
                    ", silakan laporkan postingan tersebut ke",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "@superadmin"
                    }),
                    " supaya moderator kami dapat menindaklanjuti."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Stockbit"
                    }),
                    " menanggapi secara serius segala pelanggaran etika dalam House Rules demi menjaga platform agar tetap kondusif."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                as: "h4",
                style: {
                    marginBottom: "0.8em"
                },
                children: "Bagaimana Jika Saya Menemukan Postingan yang Melanggar?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Jika kamu menemukan postingan atau komentar yang berpotensi menimbulkan kegaduhan, silakan laporkan pelanggaran menggunakan fitur Report Abuse."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Ikuti langkah berikut untuk menggunakan fitur",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Report Abuse"
                        })
                    }),
                    ":",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    "Klik ikon titik tiga di sebelah kanan ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "username"
                                    }),
                                    " yang memposting konten"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    "Pilih ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Report Abuse"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    "Pilih ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Report Type"
                                    }),
                                    " atau tipe pelanggaran yang dilakukan"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Isi alasan laporan"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    "Klik ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Confirm"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Kamu juga dapat melaporkan langsung dengan tag langsung",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "@SuperAdmin"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Stockbit"
                    }),
                    " menanggapi secara serius segala pelanggaran etika dalam House Rules demi menjaga platform agar tetap kondusif."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                family: "bold",
                as: "h4",
                style: {
                    marginBottom: "0.8em"
                },
                children: [
                    "Bagaimana Cara Saya ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Block User"
                    }),
                    "?"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Fitur Block"
                    }),
                    " digunakan untuk memblokir ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "user"
                    }),
                    " ",
                    "tertentu sehingga postingan orang tersebut tidak muncul di halaman Stream. Untuk mengaktifkan fitur ini, bisa menggunakan cara-cara berikut.",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Klik More berupa simbol titik tiga yang tertera pada postingan"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    "Pilih Block User dan klik ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "Save"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    "Maka postingan ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "user"
                                    }),
                                    " tersebut tidak akan muncul kembali"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    as: "span",
                    children: "***"
                })
            })
        ]
    });
};
/* harmony default export */ var rules = (Rules);

;// CONCATENATED MODULE: ./pages/rules.tsx

__webpack_require__(14473);


var UserArticleLayout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(74885), __webpack_require__.e(25287), __webpack_require__.e(94119), __webpack_require__.e(78656), __webpack_require__.e(71577), __webpack_require__.e(75819), __webpack_require__.e(88069), __webpack_require__.e(46819), __webpack_require__.e(7648), __webpack_require__.e(25935), __webpack_require__.e(51225), __webpack_require__.e(80129), __webpack_require__.e(40142), __webpack_require__.e(80737), __webpack_require__.e(50299), __webpack_require__.e(77549), __webpack_require__.e(54253), __webpack_require__.e(54005), __webpack_require__.e(91036), __webpack_require__.e(76750), __webpack_require__.e(97751), __webpack_require__.e(75216), __webpack_require__.e(44912), __webpack_require__.e(62571), __webpack_require__.e(21671), __webpack_require__.e(74768), __webpack_require__.e(40927), __webpack_require__.e(77284), __webpack_require__.e(42227), __webpack_require__.e(15712), __webpack_require__.e(98374)]).then(__webpack_require__.bind(__webpack_require__, 12661));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12661)
            ];
        }
    }
});
var ArticleLayout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25287), __webpack_require__.e(94119), __webpack_require__.e(71577), __webpack_require__.e(75819), __webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(76750), __webpack_require__.e(97751), __webpack_require__.e(19955), __webpack_require__.e(10534), __webpack_require__.e(73942)]).then(__webpack_require__.bind(__webpack_require__, 10534));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10534)
            ];
        }
    }
});
var RulesPage = function(param) {
    var isLoggedIn = param.isLoggedIn;
    if (isLoggedIn) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserArticleLayout, {
            source: /*#__PURE__*/ (0,jsx_runtime.jsx)(rules, {}),
            title: "House Rules"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleLayout, {
        source: /*#__PURE__*/ (0,jsx_runtime.jsx)(rules, {}),
        title: "Rules"
    });
};
var __N_SSP = true;
/* harmony default export */ var pages_rules = (RulesPage);


/***/ }),

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 95541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n  width: ",
        ";\n  text-transform: ",
        ";\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  & > a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var familyType = {
    regular: "ProximaNovaRg",
    light: "ProximaNovaLt",
    bold: "ProximaNovaBd"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "ellipsis",
            "textTransform"
        ].includes(prop);
    }
}).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "14px",
        weight: props.weight || "normal",
        height: props.height || "normal",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis,
        align: props.align || "left",
        padding: props.padding || 0,
        width: props.width,
        ellipsis: props.ellipsis,
        textTransform: props.textTransform,
        family: props.family || "regular"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8a078c1d-0"
})(_templateObject3(), function(param) {
    var family = param.family;
    return familyType[family];
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(param) {
    var height = param.height;
    return height;
}, function(props) {
    return props.color;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}));


/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 52115:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.5.7/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.6/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 36305:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [63332,49774,92888,40179], function() { return __webpack_exec__(38340); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);